import { create } from "zustand";

interface UIState {
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;
  productLayout: "grid" | "list";
  setProductLayout: (layout: "grid" | "list") => void;
  cartOpen: boolean;
  setCartOpen: (open: boolean) => void;
  categoriesOpen: boolean;
  setCategoriesOpen: (open: boolean) => void;
  /** A full-screen viewer (image lightbox) is open: hide the tab bar. */
  fullscreenOpen: boolean;
  setFullscreenOpen: (open: boolean) => void;
  /** Title for the phone top bar on inner pages (set by PageMeta). */
  pageTitle: string;
  setPageTitle: (title: string) => void;
}

export const useUI = create<UIState>((set) => ({
  searchOpen: false,
  setSearchOpen: (searchOpen) => set({ searchOpen }),
  productLayout: "grid",
  setProductLayout: (productLayout) => set({ productLayout }),
  cartOpen: false,
  setCartOpen: (cartOpen) => set({ cartOpen }),
  categoriesOpen: false,
  setCategoriesOpen: (categoriesOpen) => set({ categoriesOpen }),
  fullscreenOpen: false,
  setFullscreenOpen: (fullscreenOpen) => set({ fullscreenOpen }),
  pageTitle: "",
  setPageTitle: (pageTitle) => set({ pageTitle }),
}));
